import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import { GetObjectLogs } from '../../../store/ObjectLogAction';
import * as LogTypes from '../../../util/FlowSyncLoggerTypes';
import ObjectLogs from '../../misc/ObjectLogs';
import { CoreObjectLogs } from '../../../models/CoreObjectLogs';
import { useTranslation } from 'react-i18next';
import { RequestState } from '../../../models/RequestState';
import { RootState } from '../../../store/store';



const GroupViewObjectLogs = () => {
    const { t } = useTranslation('schoolAdministration');

    const { groupId } = useParams();
    const dispatch = useDispatch();
    const objectLogs = useSelector<RootState, RequestState<CoreObjectLogs[]>>(state => state.objectLog.objectLogs);

    useEffect(() => {
        if (groupId) {
            GetObjectLogs({ objectId: groupId, objectSource: LogTypes.Flowsync.SourceName, objectType: LogTypes.Flowsync.Group })(dispatch);
        }
    }, [dispatch, groupId]);

    return (<>
        <ObjectLogs
            objectLogs={objectLogs}
            noResMsg={t('noResult.groupObjectLogs', { ns: 'schoolAdministration' })}
        />
    </>);
}

export default GroupViewObjectLogs;
